import CarouselLayout from 'components/Content/ProductListLayout/CarouselLayout';
import GridLayout from 'components/Content/ProductListLayout/GridLayout';
import RougeExclusiveRewardsCarouselLayout from 'components/Content/ProductListLayout/RougeExclusiveRewardsCarouselLayout';

export default {
    CarouselLayout,
    GridLayout,
    RougeExclusiveRewardsCarouselLayout
};
